import { motion } from "framer-motion";
import { ShieldCheck, GraduationCap, Rocket } from "lucide-react";
import { useLang } from "@/i18n";

const icons = [ShieldCheck, GraduationCap, Rocket];

export const Manifesto = () => {
  const { t } = useLang();
  return (
    <section id="manifesto" className="relative py-24 sm:py-32 overflow-hidden" data-testid="manifesto-section">
      <img src="/images/logo-watermark.png" alt="" aria-hidden="true"
        className="pointer-events-none select-none absolute -right-28 top-1/2 -translate-y-1/2 w-[36rem] max-w-none" />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-2xl"
        >
          <span className="font-mono-ed text-xs uppercase tracking-[0.22em] text-[#0284C7]">{t.manifesto.label}</span>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-[#0B2530] mt-4 leading-tight">
            {t.manifesto.h2a}<em className="font-serif-ed italic font-medium text-[#06B6D4]">{t.manifesto.h2em}</em>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 mt-14">
          {t.manifesto.chapters.map((c, i) => {
            const Icon = icons[i];
            const n = `0${i + 1}`;
            return (
              <motion.article
                key={n}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.8, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
                className="group relative rounded-3xl bg-white border border-[#DCEEF5] p-8 sm:p-10 hover:-translate-y-1.5 hover:shadow-xl hover:shadow-sky-500/10 transition-all duration-300"
                data-testid={`manifesto-chapter-${n}`}
              >
                <span className="watermark absolute top-6 right-7 text-6xl text-[#E8F5FB] group-hover:text-[#CFF3FB] transition-colors duration-500">{n}</span>
                <Icon size={30} strokeWidth={1.6} className="text-[#06B6D4]" />
                <h3 className="font-display text-xl sm:text-2xl font-bold text-[#0B2530] mt-6">{c.t}</h3>
                <p className="text-sm sm:text-base text-[#3D5A66] leading-relaxed mt-4">{c.x}</p>
              </motion.article>
            );
          })}
        </div>
      </div>
    </section>
  );
};
